import Vue from 'vue'
import AuthService from './auth.service'
/** 
 * 病患下单检测服务
 */
export default {
    /**
     * 自主下单
     * @param {*} [params={}]
     * @param {*} [config={}]
     * @returns
     */
    async createOrderInfo(params = {}, config = {}) {
        AuthService.getToken();
        let result = await Vue.http.post('/UserOrderInfo/CreateOrderInfo', params, config);
        return result;
    },
    /**
     * 获取用户订单列表
     * @param {*} params 
     * @param {*} config 
     */
    async GetUserOrderInfoByUserID(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/UserOrderInfo/GetUserOrderInfoByUserID', config);
        return result;
    },
    /**
     * 获取订单列表
     * @param {*} params 
     * @param {*} config 
     */
    async GetUserOrderInfoList(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/UserOrderInfo/GetUserOrderInfoList', config);
        return result;
    },
    /**
     * 通过订单号获取订单详情
     * @param {*} [params={OrderID}]
     * @param {*} [config={}]
     * @returns
     */
    async GetOrderDetailModelByOrderID(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/UserOrderInfo/GetOrderDetailModelByOrderID', config);
        return result;
    },
    /**
     * 删除订单，只删除未支付、支付失败订单
     * @param {*} [params={}]
     * @param {*} [config={}]
     * @returns
     */
    async DeleteOrder(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.delete('/UserOrderInfo/DeleteOrder', config);
        return result;
    },
}


// WEBPACK FOOTER //
// ./src/_services/user.order.info.service.js